import { LENS_VIEW_PARAM, lensViewParamValue } from '../LeLens/lensUrlState';

/** Keep reader scope from saved standalone Lens links when entering the unified shell. */
export function legacyLensUrl(lensId: string | undefined, search: string, hash = ''): string {
  const params = new URLSearchParams(search);
  const scope = lensViewParamValue(params);
  if (lensId && scope) {
    params.set(LENS_VIEW_PARAM, scope);
  }
  params.set('view', lensId ? 'lens' : 'lensIndex');
  if (lensId) {
    params.set('lens', lensId);
  } else {
    params.delete('lens');
    params.delete('card');
    params.delete(LENS_VIEW_PARAM);
  }
  return `/ask-richard-unified?${params.toString()}${hash}`;
}
